module.exports = __webpack_public_path__ + "static/media/sale.0a7f0b83.svg";